module.exports = __webpack_public_path__ + "static/media/mp_female.68167b6c.png";